import { BsPeople } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';
import { useAuth } from '#globalContexts/AuthProvider';
import { useOrgMembers, useOrgCredits } from '#orgFeature/models/org/queries';
import { useAddSeat } from '#settingsFeature/models/billing/mutations';

import { CreditsOverview } from './components/CreditsOverview';
import { InviteMember } from './components/InviteMember';
import { MemberList } from './components/MemberList';
import { PendingInviteList } from './components/PendingInviteList';
import { SeatCounter } from './components/SeatCounter';

const SECTION_PROPS = {
	icon: BsPeople,
	title: 'Team verwalten',
	subtitle: 'Mitglieder einladen, Rollen zuweisen und Budgets verwalten',
};

export const TeamSettings = () => {
	const { user, orgRole, orgSeats } = useAuth();
	const { data: { members = [], invites = [] } = {}, isLoading: membersLoading } = useOrgMembers(orgRole);
	const { data: orgCredits, isLoading: creditsLoading } = useOrgCredits(orgRole);
	const addSeatMutation = useAddSeat();

	if (membersLoading || creditsLoading) {
		return (
			<SectionCard {...SECTION_PROPS}>
				<div className="flex items-center justify-center py-12">
					<div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-500 border-t-transparent" />
				</div>
			</SectionCard>
		);
	}

	const usedSeats = members.length;
	const totalSeats = orgSeats?.seatsIncluded ?? 1;
	const seatsAvailable = Math.max(totalSeats - usedSeats, 0);
	const isOwner = orgRole === 'owner';

	return (
		<SectionCard {...SECTION_PROPS}>
			<div className="space-y-4">
				<div className="grid grid-cols-1 gap-4 md:grid-cols-2">
					<SeatCounter
						usedSeats={usedSeats}
						totalSeats={totalSeats}
						isOwner={isOwner}
						onAddSeat={() => addSeatMutation.mutate()}
						isAddingSeat={addSeatMutation.isPending}
					/>
					<CreditsOverview orgCredits={orgCredits} />
				</div>

				<InviteMember seatsAvailable={seatsAvailable} />

				<MemberList members={members} currentUserId={user?.id} orgRole={orgRole} />

				<PendingInviteList invites={invites} />
			</div>
		</SectionCard>
	);
};
